import './external/global.js';
import './main/external/forms/index.js';
import './external/simpleParallax.js';  
import './external/jquery.ripples.js';  
import './main/app.js';